import React from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { withTranslation } from "react-i18next"

import {
  Avatar,
  Button,
  DialogContent,
  DialogTitle,
  FormControl,
  Link,
  TextField,
  Typography
} from "@material-ui/core"

import { LockOutlined } from "@material-ui/icons"

import HKVDialog from "../../../HKVDialog/2.0"

import { doCreateUserWithEmailAndPassword, doPasswordReset, doSignInWithEmailAndPassword } from "./Functions"

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.hkv.nl/en">
        HKV Services
      </Link>
      {" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  )
}

const styles = theme => ({
  image: {
    backgroundImage: "url(\"/static/images/login.jpg\")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    [theme.breakpoints.down("md")]: {
      display: "none"
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
      display: "block"
    },
    [theme.breakpoints.up("lg")]: {
      width: "75%",
      display: "block"
    }
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(8, 4),
    boxShadow: theme.shadows[5],
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    [theme.breakpoints.up("md")]: {
      width: "50%"
    },
    [theme.breakpoints.up("lg")]: {
      width: "25%"
    }
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  }
})

class Login extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dialogAccount: null,
      dialogPassword: null,
      userinfo: {}
    }
  }

  handleChangeEmail = (event, type) => {
    const { dialogAccount, dialogPassword, userinfo } = this.state

    // 13 = enter
    if (event.keyCode === 13) {
      // Bepalen welke functie we moeten uitvoeren afhankelijk van welk textfield type we komen
      switch (type) {
        case "forgot":
          this.handlePasswordRequest(dialogPassword)
          break

        case "create":
          this.handleCreateAccount(dialogAccount)
          break
      
        default:
          this.handleLogin()
          break
      }
    }

    userinfo.email = event.target.value
    this.setState({ userinfo })
  }

  handleChangeName = (event) => {
    const { dialogAccount, userinfo } = this.state

    // 13 = enter
    if (event.keyCode === 13) {
      this.handleCreateAccount(dialogAccount)
    }

    userinfo.name = event.target.value
    this.setState({ userinfo })
  }

  handleChangePassword = (event, type) => {
    const { dialogAccount, userinfo } = this.state

    // 13 = enter
    if (event.keyCode === 13) {
      // Bepalen welke functie we moeten uitvoeren afhankelijk van welk textfield type we komen
      switch (type) {
        case "create":
          this.handleCreateAccount(dialogAccount)
          break
      
        default:
          this.handleLogin()
          break
      }
    }

    userinfo.password = event.target.value
    this.setState({ userinfo })
  }

  handleLogin = () => {
    const { dispatch } = this.props
    const { email, password } = this.state.userinfo

    // Inloggen met opgegeven credentials
    doSignInWithEmailAndPassword(email, password, dispatch)
  }

  openForgotPassword = () => {
    this.setState({ dialogPassword: { open: true, size: "medium" } })
  }

  openNoAccount = () => {
    this.setState({ dialogAccount: { open: true, size: "medium" } })
  }

  handleCreateAccount = (config) => {
    const { dispatch } = this.props
    const { email, name, password } = this.state.userinfo

    // functie voor aanmaken account
    doCreateUserWithEmailAndPassword(email, name, password, dispatch)
    this.closeDialog(config)
  }

  handlePasswordRequest = (config) => {
    const { dispatch } = this.props
    const { email } = this.state.userinfo

    // functie voor wachtwoord reset
    doPasswordReset(email, dispatch)
    this.closeDialog(config)
  }

  closeDialog = (config) => {
    config.open = false
    this.setState({ config })
  }

  render() {
    const { classes, t, theme } = this.props
    const { dialogAccount, dialogPassword } = this.state

    return (
      <React.Fragment>
        <div style={{ display: "flex", height: "100%" }}>
          <div className={classes.image} />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlined />
            </Avatar>
            <Typography component="h1" variant="h5">
              {t("Log in")}
            </Typography>
            <FormControl className={classes.form}>
              <TextField
                autoFocus
                autoComplete="email"
                required
                fullWidth
                label={t("E-mail")}
                variant="outlined"
                style={{ marginBottom: theme.spacing(2) }}
                onKeyUp={(event) => this.handleChangeEmail(event)}
              />
              <TextField
                required
                fullWidth
                label={t("Password")}
                type="password"
                variant="outlined"
                style={{ marginBottom: theme.spacing(2) }}
                onKeyUp={(event) => this.handleChangePassword(event)}
              />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginBottom: theme.spacing(2) }}
                onClick={() => this.handleLogin()}
              >
                {t("Log in")}
              </Button>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  style={{ cursor: "pointer" }}
                  color="primary"
                  variant="body2"
                  onClick={() => this.openForgotPassword()}
                >
                  {t("Wachtwoord vergeten")}
                </Typography>
                {/* <Typography
                  style={{ cursor: "pointer" }}
                  color="primary"
                  variant="body2"
                  onClick={() => this.openNoAccount()}
                >
                  {t("Account aanmaken")}
                </Typography> */}
              </div>
              <div style={{ padding: theme.spacing(5) }}>
                <Copyright />
              </div>
            </FormControl>
          </div>
        </div>
        <HKVDialog config={dialogAccount} onClose={this.closeDialog}>
          <DialogTitle>{t("Account aanmaken")}</DialogTitle>
          <DialogContent>
            <Typography>{t("Vul je gegevens in om een account aan te vragen.")}</Typography>
            <FormControl className={classes.form}>
              <TextField
                autoFocus
                autoComplete="email"
                required
                fullWidth
                size="small"
                label={t("E-mail")}
                variant="outlined"
                style={{ marginBottom: theme.spacing(2) }}
                onKeyUp={(event) => this.handleChangeEmail(event, "create")}
              />
              <TextField
                autoComplete="name"
                required
                fullWidth
                size="small"
                label={t("Naam")}
                variant="outlined"
                style={{ marginBottom: theme.spacing(2) }}
                onKeyUp={(event) => this.handleChangeName(event)}
              />
              <TextField
                required
                fullWidth
                size="small"
                label={t("Wachtwoord")}
                type="password"
                variant="outlined"
                style={{ marginBottom: theme.spacing(2) }}
                onKeyUp={(event) => this.handleChangePassword(event, "create")}
              />
            </FormControl>
            <div className='dialog-actions'>
              <Button color='primary' variant='contained' className='dialog-button' onClick={() => this.handleCreateAccount(dialogAccount)}>
                {t("Ok")}
              </Button>
            </div>
          </DialogContent>
        </HKVDialog>
        <HKVDialog config={dialogPassword} onClose={this.closeDialog}>
          <DialogTitle>{t("Wachtwoord vergeten")}</DialogTitle>
          <DialogContent>
            <Typography>{t("Voer je e-mailadres in en we sturen je een link om je wachtwoord opnieuw in te stellen.")}</Typography>
            <FormControl className={classes.form}>
              <TextField
                autoFocus
                autoComplete="email"
                required
                fullWidth
                size="small"
                label={t("Email")}
                variant="outlined"
                style={{ marginBottom: theme.spacing(2) }}
                onKeyUp={(event) => this.handleChangeEmail(event, "forgot")}
              />
            </FormControl>
            <div className='dialog-actions'>
              <Button color='primary' variant='contained' className='dialog-button' onClick={() => this.handlePasswordRequest(dialogPassword)}>
                {t("Ok")}
              </Button>
            </div>
          </DialogContent>
        </HKVDialog>
      </React.Fragment>
    )
  }
}

Login = withTranslation("translation")(Login)
Login = withStyles(styles, { withTheme: true })(Login)
export default connect(state => state)(Login)
